import React, { useState } from 'react';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { ToggleIconButton } from './ToggleIconButton';

export function ToggleIconButtonShowcase() {
  const [isSelected, setIsSelected] = useState(false);

  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Toggle Icon Button - etats selected/not-selected, ghost/primary, small/medium.
      </Text>

      <Row gap="spacing.general.x3">
        <ToggleIconButton
          accessibilityLabel="Save item"
          selected={isSelected}
          type="ghost"
          onPress={() => setIsSelected((prev) => !prev)}
        />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleIconButton accessibilityLabel="Save item" type="ghost" size="small" />
        <ToggleIconButton accessibilityLabel="Save item" type="ghost" state="hover" />
        <ToggleIconButton accessibilityLabel="Save item" type="ghost" state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleIconButton accessibilityLabel="Save item" selected type="primary" size="small" />
        <ToggleIconButton accessibilityLabel="Save item" selected type="primary" state="hover" />
        <ToggleIconButton accessibilityLabel="Save item" selected type="primary" state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleIconButton accessibilityLabel="Save item" type="primary" inverted />
        <ToggleIconButton accessibilityLabel="Save item" type="primary" size="small" inverted />
        <ToggleIconButton accessibilityLabel="Save item" selected type="primary" inverted />
      </Row>
    </Column>
  );
}
